import type { Dispatch } from 'redux';
import {
    createActionFactory,
    Feature,
    createThunk,
    ThunkDispatch,
    createMapOfSet,
    DeletedItemsSubViewType,
} from '../../../../shared';
import { HubState, packageStateKey } from '../../../state';
import { HubPersona, getCurrentHubPersonas } from '../../../selectors/currentPersonaSelector';
import { restoreContacts } from '../../data/restoreContactsDataActions';
import { getPackageState } from '../../../../appstate';

export interface RestoreContactsActionPayload {
    personas: HubPersona[];
    displayedHubPersonaIds: string[];
}

export const dismissRestoreContactsDialogAction = createActionFactory<void>(
    'DismissRestoreContactsDialogAction',
    Feature.RestoreDeletedContacts
);

export const dismissRestoreContactsDialog = (dispatch: Dispatch) => () =>
    dispatch(dismissRestoreContactsDialogAction());

export const restoreContactsClickedAction = createActionFactory<RestoreContactsActionPayload>(
    'RestoreContactsClickedAction',
    Feature.RestoreDeletedContacts,
    action => ({
        items: action.payload.personas.length,
    })
);

export const restoreContactsClicked = createThunk(
    'RestoreContactsClicked',
    (dispatch: ThunkDispatch, getState: () => {}) => {
        const state = getPackageState<HubState>(getState(), packageStateKey);

        const subView = state.packageState.view.deletedItemsFolderState.deletedItemsSubViewType;
        const currPersonas = getCurrentHubPersonas(state.appState, state.packageState);

        const deletedHubPersonaIds = state.appState.data.hubState.deletedPersonasState.deletedPersonas.map(
            persona => persona.hubPersonaId
        );
        const deletedHubPersonaIdsMap = createMapOfSet(deletedHubPersonaIds);

        const recoverableHubPersonaIds = state.appState.data.hubState.deletedPersonasState.recoverablePersonas.map(
            persona => persona.hubPersonaId
        );
        const recoverableHubPersonaIdsMap = createMapOfSet(recoverableHubPersonaIds);

        const displayedHubPersonaIds =
            subView === DeletedItemsSubViewType.RecoverableContactsFolder
                ? recoverableHubPersonaIds
                : deletedHubPersonaIds;
        const displayedHubPersonaIdsMap =
            subView === DeletedItemsSubViewType.RecoverableContactsFolder
                ? recoverableHubPersonaIdsMap
                : deletedHubPersonaIdsMap;
        const personasFromCurrentHubList = currPersonas.filter(
            persona => displayedHubPersonaIdsMap[persona.hubPersonaId]
        );
        const actionPayload: RestoreContactsActionPayload = {
            personas: personasFromCurrentHubList,
            displayedHubPersonaIds: displayedHubPersonaIds,
        };

        dispatch(restoreContactsClickedAction(actionPayload));
        dispatch(restoreContacts(actionPayload));
    }
);
export type { Action } from '../../../../shared';
